<div [class]="positionPreset[position]">
    <ng-content></ng-content>
    <ng-container></ng-container>
</div>
